import type FastPhonicsProgressReviewStudentsRoute from 'teacher-ui-client/reporting/ui-scope/fast-phonics/progress/review/students/route'
import TablesPeaksProgressStudents from 'teacher-ui-client/components/tables/peaks-progress/students'
import RouteTemplate from 'ember-route-template'
import type { TOC } from '@ember/component/template-only'
import type FastPhonicsReportingProgressReviewStudentsController from 'teacher-ui-client/reporting/ui-scope/fast-phonics/progress/review/students/controller'

interface Signature {
  Args: {
    model: ModelFor<FastPhonicsProgressReviewStudentsRoute>
    controller: FastPhonicsReportingProgressReviewStudentsController
  }
}

export const FastPhonicsProgressReviewStudentsPage: TOC<Signature> = <template>
  <TablesPeaksProgressStudents
    @students={{@model.students}}
    @onStudentClick={{@controller.transitionToStudentRoute}}
    @onSortClick={{@controller.updateSorts}}
    @sortingConfig={{@controller.sortingConfig}}
    @paginationConfig={{@controller.paginationConfig}}
    @exportable={{true}}
  />
</template>

export default RouteTemplate(FastPhonicsProgressReviewStudentsPage)
